var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"max-width":"600px"},attrs:{"src":require("../assets/images/infographic.jpg"),"width":"100%","height":"auto"}})])
}]

export { render, staticRenderFns }